module.exports = __webpack_public_path__ + "img/selected4-min.69940a56.png";